import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightDots, faBook, faClipboardCheck, faFileLines, faGear, faGripVertical, faLayerGroup, faRulerVertical, faSeedling } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { GerarBookFertResu } from "./styled";

//APP
import { useGetElementosFertilidade } from "../../../../../../../../services/novoConfigBook/get";
import { ResultadoAnaliseOS__Item, useGetResultadoAnaliseOS } from "../../../../../../../../services/AgriculturaPrecisao/bookResumido/GET";
import { descricaoDefinicao, filtrarApenasPropriedade, obterProfundidades, processarAnalise, talhoesComPedido } from "./meta";

//COMPONENTS
import Tabs from "../../../../../../../../Components/Tabs";
import Input from "../../../../../../../../Components/CustomUi/input";
import Carregando from "../../../../../../../../Components/CustomUi/loading";
import ButtonCustom from "../../../../../../../../Components/ButtonCustom";
import { Box } from "../../../../../../../../Components/CustomUi/box";
import { Inline } from "../../../../../../../../Components/CustomUi/inline";
import { Render } from "../../../../../../../../Components/CustomUi/render";
import { Select } from "../../../../../../../../Components/CustomUi/Select";
import { Warning } from "../../../../../../../../Components/CustomUi/warning";
import { RowItem } from "../../../../../../../../Components/CustomUi/table/rowItem";
import { TitleH4 } from "../../../../../../../../Components/CustomUi/titleH4";
import { RowTable } from "../../../../../../../../Components/CustomUi/table/rowTable";
import { Switcher } from "../../../../../../../../Components/CustomUi/Switcher";
import { BodyTable } from "../../../../../../../../Components/CustomUi/table/bodyTable";
import { SelectMulti } from "../../../../../../../../Components/CustomUi/SelectMulti";
import { HeaderTable } from "../../../../../../../../Components/CustomUi/table/headerTable";
import { removerAcentos } from "../../../../../../../../utils";
import { infoAlert } from "../../../../../../../../utils/alert";

//PROPS
interface Props {
    cod_propriedade: number,
    lista_talhoes: { cod_talhao: number, nome_talhao: string, cod_pedido: number }[];
    setOpen_gaveta_book: React.Dispatch<React.SetStateAction<boolean>>;
    setLista_dados_os: React.Dispatch<React.SetStateAction<ResultadoAnaliseOS__Item[]>>;
    setCods_elementos_selecionados: React.Dispatch<React.SetStateAction<number[]>>;
    setTalhoes_filtrados: React.Dispatch<React.SetStateAction<number[]>>;
    setProfundidades_filtrar_selecionadas: React.Dispatch<React.SetStateAction<string[]>>;
    setTipo_representacao_selecionada: React.Dispatch<React.SetStateAction<'Interpretado' | 'Distribuído'>>;
    setQualidade_definicao_krigagem: React.Dispatch<React.SetStateAction<'Automática'|'Definição baixa'|'Definição padrão'|'Definição melhorada'>>;
    agrupar_talhoes: boolean;
    setAgrupar_talhoes: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalGerarBookFertilidadeResumido: React.FC<Props> = ({ lista_talhoes, cod_propriedade, setOpen_gaveta_book, 
    setLista_dados_os, setCods_elementos_selecionados, setTalhoes_filtrados, setProfundidades_filtrar_selecionadas, 
    setTipo_representacao_selecionada, setQualidade_definicao_krigagem, agrupar_talhoes, setAgrupar_talhoes }) => {

    //CONSTs
    const qualidade_definicoes = [
        {id: 0, descricao:'Automática', pixels: 777},
        {id: 2, descricao:'Definição baixa', pixels: 0.0005},
        {id: 3, descricao:'Definição padrão', pixels: 0.0003},
        {id: 4, descricao:'Definição melhorada', pixels: 0.0001},
    ];

    //STATES
    const [open_select_talhao, setOpen_select_talhao] = useState<boolean>(false);
    const [talhoes_selecionados, setTalhoes_selecionados] = useState<{ descr: string, id: number, key?: number }[]>([]);
    const [open_select_profundidade, setOpen_select_profundidade] = useState<boolean>(false);
    const [profundidade_selecionadas, setProfundidades_selecionadas] = useState<{ descr: string, id: number, key?: number }[]>([]);
    const [tab_tipo_representacao_mapa, setTab_tipo_representacao_mapa] = useState<'Interpretado' | 'Distribuído'>('Interpretado');
    const [buscar_elemento, setBuscar_elemento] = useState<string>('');
    const [tab_tipo_de_mapa, setTab_tipo_de_mapa] = useState<'Fertilidade' | 'Indicadores' | 'Prescrições'>('Fertilidade');
    const [selecionar_todos_elementos, setSelecionar_todas_elementos] = useState<boolean>(false);
    const [cods_selecionado_switcher, setCods_selecionado_switcher] = useState<number[]>([]);
    const [loading_gerar_book, setLoading_gerar_book] = useState<boolean>(false);
    const [definicao_inicial_do_mapa, setDefinicao_inicial_do_mapa] = useState<'Automática'|'Definição baixa'|'Definição padrão'|'Definição melhorada'>('Automática');
    const [open_select_definicao, setOpen_select_definicao] = useState<boolean>(false);
    //API
    const { data_resultado, carregando_resultado, isFetched_resultado } = useGetResultadoAnaliseOS(cod_propriedade);
    const { data_elementos, carregando_elementos } = useGetElementosFertilidade();

    //EFFECTS
    useEffect(() => {
        if (isFetched_resultado) {
            let cods = (processarAnalise(data_resultado, cod_propriedade) ?? []).map(i => i.cod_elemento);
            setCods_selecionado_switcher(cods);
        }
        
    }, [data_resultado]);
    
    useEffect(() => {
        if (cods_selecionado_switcher.length === (processarAnalise(data_resultado, cod_propriedade) ?? []).length) {
            setSelecionar_todas_elementos(true);
        }
        else {
            setSelecionar_todas_elementos(false);
        }
    }, [cods_selecionado_switcher])


    //FUNCTIONS
    function selecionarElemento(cod_elemento: number) {
        setCods_selecionado_switcher(cods_selecionado_switcher => [...cods_selecionado_switcher, cod_elemento]);
    }
    function desselecionarElemento(cod_elemento: number) {
        let remove = cods_selecionado_switcher.filter(cod => cod !== cod_elemento);
        setCods_selecionado_switcher(remove);
    }
    function selecionarDeselecionarTodos() {
        if (selecionar_todos_elementos) {
            setCods_selecionado_switcher([]);
            setSelecionar_todas_elementos(false);
        }
        else {
            let cods = (processarAnalise(data_resultado, cod_propriedade) ?? []).map(i => i.cod_elemento);
            setCods_selecionado_switcher(cods);
            setSelecionar_todas_elementos(true);
        }
    }
    function gerarBookFertiResumido() {

        let filtrar_cods_config = cods_selecionado_switcher.filter((cod)=> !isOcultoNasConfigBook(cod));

        // let data_filtrada_por_talhao = filtrarPorTalhao(data_resultado, talhoes_selecionados);

        setTalhoes_filtrados(talhoes_selecionados.map(i=>i.id))
        setProfundidades_filtrar_selecionadas(profundidade_selecionadas.map(item=>item.descr));
        setCods_elementos_selecionados(filtrar_cods_config);
        setTipo_representacao_selecionada(tab_tipo_representacao_mapa);
        setQualidade_definicao_krigagem(definicao_inicial_do_mapa);
        setLoading_gerar_book(true);
        setLista_dados_os(filtrarApenasPropriedade(data_resultado, cod_propriedade));

        setTimeout(() => {
            setLoading_gerar_book(false);
            setOpen_gaveta_book(true);
        }, 1000);
    };
    
    function isOcultoNasConfigBook(cod_elemento: number) {
        let configuracoes = data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes ?? [];
        
        let info_elemento = configuracoes?.find(item=> item.elemento === cod_elemento);
        let visivel_na_secao = info_elemento?.secoes?.[0]?.visivel;

        if (info_elemento===undefined) {
            return false;
        }

        if (!visivel_na_secao) {
            return true; //OCULTO NA SEÇÃO DELE (Fertilidade / indicadores / precrições)
        }

        return false;
    }

    function encontrarElemento(buscar_nome: string) {
        const ativoSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.[`elemento_descricao`]))
            return nomeSemAcentos.toLowerCase().includes(ativoSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    useEffect(() => {

        if (isFetched_resultado && data_resultado.length > 0 && !carregando_resultado) {
            let pedidos = talhoesComPedido(lista_talhoes, data_resultado, cod_propriedade).map(item=> item.cod_pedido);
            let faltando = lista_talhoes.filter(item=> !(pedidos.includes(item.cod_pedido)));
            
            if (faltando.length > 0) {
                for (let i = 0; i < faltando.length; i++) {
                    infoAlert(`Talhão " ${faltando?.[i]?.nome_talhao} " será removido do book pois não possui nenhuma OS!`, 7000)
                }
            }
        }
        
        
    }, [data_resultado])
    
    
    return (
        <GerarBookFertResu>
            <div className="GerarBookFertResu__content">

                <Box style={{ width: '37%' }}>
                    <TitleH4>Filtros do book</TitleH4>

                    <Tabs
                        label="forma de apresentar os mapas"
                        tabs={[
                            { descricao: 'Interpretado', icone: faClipboardCheck, width: 150 },
                            { descricao: 'Distribuído', icone: faGripVertical, width: 150 }
                        ]}
                        selecionado={tab_tipo_representacao_mapa}
                        onChange={setTab_tipo_representacao_mapa}
                        labelFontSize={12}
                    />

                    <SelectMulti
                        label="Selecione os talhões"
                        placeholder="Selecione os talhões"
                        items={talhoesComPedido(lista_talhoes, data_resultado, cod_propriedade) ?? []}
                        descricaoItem="nome_talhao"
                        idItem="cod_pedido"
                        open={open_select_talhao}
                        trigger={setOpen_select_talhao}
                        onChange={setTalhoes_selecionados}
                        selecteds={talhoes_selecionados}
                        opcional
                        icon={faLayerGroup}
                        disabled={carregando_resultado}
                    />

                    <SelectMulti
                        label="Selecione as profundidades"
                        placeholder="Selecione as profundidades"
                        items={obterProfundidades(data_resultado, cod_propriedade) ?? []}
                        descricaoItem="profundidade"
                        idItem="cod_profundidade"
                        open={open_select_profundidade}
                        trigger={setOpen_select_profundidade}
                        onChange={setProfundidades_selecionadas}
                        selecteds={profundidade_selecionadas}
                        opcional
                        icon={faRulerVertical}
                    />

                    <Select 
                        label="Definição do mapa"
                        value={definicao_inicial_do_mapa}
                        onChange={setDefinicao_inicial_do_mapa}
                        items={qualidade_definicoes}
                        descricaoItem="descricao"
                        idItem="id"
                        open={open_select_definicao}
                        trigger={setOpen_select_definicao}
                        icon={faGear}
                        allowClear={false}
                    />

                    <Warning type={definicao_inicial_do_mapa==='Definição melhorada' ? "warning" : "info"} style={{marginTop: 5}}>
                        [{definicao_inicial_do_mapa}]: {descricaoDefinicao(definicao_inicial_do_mapa)}
                    </Warning>

                    {/* <Switcher 
                        isChecked={agrupar_talhoes}
                        trigger={setAgrupar_talhoes}
                        label='Agrupar talhões'
                        style={{marginTop: 7}}
                    /> */}

                </Box>
                <Box style={{ width: '63%' }}>
                    <TitleH4>Mapas que serão exibidas no book</TitleH4>

                    <Tabs
                        labelFontSize={13}
                        tabs={[
                            { descricao: 'Fertilidade', width: 179, icone: faSeedling },
                            { descricao: 'Indicadores', width: 179, icone: faArrowUpRightDots },
                            { descricao: 'Prescrições', width: 179, icone: faFileLines },
                        ]}
                        selecionado={tab_tipo_de_mapa}
                        onChange={setTab_tipo_de_mapa}
                        indexInicial={0}
                        style={{ marginTop: -10 }}
                    />

                    <Inline>
                        <Input
                            placeholder="Buscar elemento"
                            value={buscar_elemento}
                            onChange={setBuscar_elemento}
                            width={340}
                        />

                        <Switcher
                            label='Selecionar todos'
                            isChecked={selecionar_todos_elementos}
                            trigger={() => { }}
                            task={() => { selecionarDeselecionarTodos() }}
                        />
                    </Inline>

                    <HeaderTable
                        itens={[
                            { valor: 'Exibir', width: 81 },
                            { valor: 'Elemento', width: 'calc(100% - 80px)' },
                        ]}
                    />

                    <Render condition={carregando_resultado || carregando_elementos}>
                        <div style={{ width: '100%' }}>
                            <Carregando
                                animation
                                height={313}
                                legenda="Carregando elementos..."
                                justifyContent="center"
                            />
                        </div>
                    </Render>

                    <Render condition={!carregando_resultado && !carregando_elementos}>
                        <BodyTable style={{ marginTop: -10, overflowY: 'scroll', height: 'calc(100vh - 470px)' }}>
                            {(processarAnalise(data_resultado, cod_propriedade, data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes) ?? []).filter(i => i.tipo_mapa === tab_tipo_de_mapa).filter(encontrarElemento(buscar_elemento)).map(({ elemento_descricao, cod_elemento }, index) => {

                                let isSelecionado = cods_selecionado_switcher.includes(cod_elemento);

                                return (
                                    <RowTable key={index}>
                                        <RowItem width={80}>
                                            <Switcher
                                                isChecked={isOcultoNasConfigBook(cod_elemento) ? false : isSelecionado}
                                                trigger={() => { }}
                                                task={isSelecionado ? () => desselecionarElemento(cod_elemento) : () => selecionarElemento(cod_elemento)}
                                                disabled={isOcultoNasConfigBook(cod_elemento)}
                                            />
                                        </RowItem>
                                        <RowItem width={'calc(100% - 80px)'} style={{opacity: isSelecionado ? 1 : 0.6}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                {elemento_descricao}
                                                <Render condition={isOcultoNasConfigBook(cod_elemento)}>
                                                    <small style={{color: '#bf0000', marginTop: -5}}>ocultado nas configurações do book</small>
                                                </Render>
                                            </div> 
                                        </RowItem>
                                    </RowTable>
                                )
                            })}
                        </BodyTable>

                    </Render>



                </Box>


            </div>

            <div className="GerarBookFertResu__footer">
                <ButtonCustom
                    icon={<FontAwesomeIcon icon={faBook} />}
                    onClick={() => { gerarBookFertiResumido() }}
                    loading={loading_gerar_book}
                    disabled={carregando_resultado || carregando_elementos || (cods_selecionado_switcher.length === 0)}
                >
                    Gerar book agrupado
                </ButtonCustom>
            </div>
        </GerarBookFertResu>
    )
}